import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo, useState } from 'react';
import { calculateStylesForDesktop } from "../utils";
export var useCalculateStyles = function useCalculateStyles(_ref) {
  var isMobile = _ref.isMobile,
    parentRect = _ref.parentRect;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    balancesWrapper = _useState2[0],
    setBalancesWrapper = _useState2[1];
  var style = useMemo(function () {
    return isMobile ? undefined : calculateStylesForDesktop({
      balancesWrapper: balancesWrapper,
      parentRect: parentRect
    });
  }, [balancesWrapper, isMobile, parentRect]);
  return {
    style: style,
    setBalancesWrapper: setBalancesWrapper
  };
};